// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TripCards_trip-container__2efy\\+{
    width: 84vw;
    height: auto;
    display: flex;
    flex-flow: wrap;
    justify-content: flex-start;
    row-gap: 2.2vw;
    margin: 4vw auto 2vw;
}

.TripCards_trip-card__12GCk{
    width: 26.1vw;
    height: 26.1vw;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 2vw;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-right: 1.3vw;
}

.TripCards_trip-card__12GCk:hover{
    transform: scale(1.05);
    transition: 0.3s;
    box-shadow: 1px 1px 10px 2px grey; 
}

.TripCards_upper-card__p-Rf6{
    width: 100%;
    height: 16vw;
    overflow: hidden;
}

.TripCards_upper-card-img-container__NmGsL{
    position: absolute;
    width: 26vw;
    height: 16vw;
    border-radius: 2vw 2vw 0 0;
    overflow: hidden;
    z-index: 0;
}

.TripCards_upper-card-img__oHcox{
    width: 100%;
    height: 16vw;
    overflow: hidden;
    object-fit: cover;
    cursor: pointer;
}

.TripCards_trip-category-container__Bd4gc{
    position: relative;
    width: max-content;
    /* width:14vw;margin-left:14vw;padding-right: 0; */
    height: 1.7vw;
    margin-top: 12.5vw;
    margin-left: auto;
    padding-right: 0.5vw;
    background-image: url("https://static.wixstatic.com/media/dd0cc5_7c84882dec3040feaf73ea5dabf78e14~mv2.webp");
}

.TripCards_trip-category-text__XA\\+m2{
    margin-top: 0;
    margin-bottom: 0;
    color: white;
    text-align: center;
    font-size: 1vw;
    margin-left: 0.5vw;
    align-self: center;
    font-family: dm-sans-light;
    font-weight: bold;
    cursor: pointer;
}

.TripCards_vacancy-container__7GYCp{
    width: 10vw;
    height: 1.7vw;
    margin-top: -13vw;
    margin-left: -2vw;
    justify-content: center;
    align-items: center;
    background-image: url("https://static.wixstatic.com/media/dd0cc5_7c84882dec3040feaf73ea5dabf78e14~mv2.webp");
    transform: rotate(-38deg);
    display: flex;
}

.TripCards_vacancy-text__8OKGz{
    font-size: 0.8vw;
    color: white;
    font-family: dm-sans-light;
    font-weight: bold;
    cursor: pointer;
}

.TripCards_lower-card__OVXzc{
    display: flex;
    flex-direction: column;
    width: auto;
    height: 10.1vw;
    color: black;
    padding-left: 1vw;
}

.TripCards_lower-card-text__bM1mC{
    font-size: 1.2vw;
    margin-bottom: 0px;
    margin-top: 0.5vw;
    font-family: dm-sans-light;
    cursor: default;
}

.TripCards_lower-card-text-bold__cCqle{
    font-weight:bolder;
    font-family: dm-sans-medium;
}

.TripCards_lower-card-button__FGdw2{
    position: absolute;
    width: 8vw;
    height: 2vw;
    margin-top: 7vw;
    border-radius: 1vw;
    border: none;
    background-color: rgb(230, 84, 57);
    color: white;
    font-size: 1.1vw;
    cursor: pointer;
    font-family: dm-sans-light;
}

.TripCards_lower-card-img__GFfe7{
    width: 5.6vw;
    height: 5.6vw;
    border-radius: 50%;
    position: absolute;
    margin-left: 18vw;
    margin-top: 2.5vw;
}


@media(max-width: 768px){
    .TripCards_trip-container__2efy\\+{
        width: 95vw;
        transform: translateY(0);
        overflow-x: scroll;
        height: auto;
        display: flex;
        flex-direction: row;
        flex-flow: nowrap;
        row-gap: 2.2vw;
        margin: 4vw auto 2vw;
        margin-left: 5vw;
        margin-bottom: 0vw;
    }
    
    .TripCards_trip-card__12GCk{
        min-width: 76vw;
        height: 93vw;
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-radius: 5vw;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        margin-right: 5vw;
    }
    
    .TripCards_upper-card__p-Rf6{
        width: 100%;
        height: 57vw;
        overflow: hidden;
    }

    .TripCards_upper-card-img-container__NmGsL{
        position: absolute;
        width: 75.7vw;
        height: 57vw;
        border-radius: 5vw 5vw 0 0;
        overflow: hidden;
        z-index: -1;
    }
    
    .TripCards_upper-card-img__oHcox{
        width: 100%;
        height: 57vw;
        overflow: hidden;
        object-fit: cover;
    }

    .TripCards_trip-category-container__Bd4gc{
        width: 25vw;
        height: 5vw;
        margin-top: 46vw;
        margin-left: 51vw;
        background-image: url("https://static.wixstatic.com/media/dd0cc5_7c84882dec3040feaf73ea5dabf78e14~mv2.webp");
    }
    
    .TripCards_trip-category-text__XA\\+m2{
        margin-top: 0;
        margin-bottom: 0;
        color: white;
        text-align: center;
        font-size: 2.2vw;
        margin-left: 2vw;
        align-self: center;
    }
    
    .TripCards_vacancy-container__7GYCp{
        width: 45vw;
        height: 4vw;
        margin-top: -47vw;
        margin-left: -14vw;
        background-image: url("https://static.wixstatic.com/media/dd0cc5_7c84882dec3040feaf73ea5dabf78e14~mv2.webp");
        transform: rotate(-38deg);
        justify-content: center;
        align-items: center;
        display: flex;
    }
    
    .TripCards_vacancy-text__8OKGz{
        font-size: 2.4vw;
        color: white;
    }
    
    .TripCards_lower-card__OVXzc{
        display: flex;
        flex-direction: column;
        width: auto;
        height: 36vw;
        color: black;
        padding-left: 2vw;
    }
    
    .TripCards_lower-card-text__bM1mC{
        font-size: 4vw;
        margin-bottom: 0px;
        margin-top: 1vw;
    }
    
    .TripCards_lower-card-button__FGdw2{
        position: absolute;
        width: 30vw;
        height: 9vw;
        margin-top: 23vw;
        border-radius: 100vw;
        border: none;
        background-color: rgb(230, 84, 57);
        color: white;
        font-size: 4vw;
    }
    
    .TripCards_lower-card-img__GFfe7{
        width: 18vw;
        height: 18vw;
        border-radius: 50%;
        position: absolute;
        margin-left: 52vw;
        margin-top: 14vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/Global/Cards/TripCards.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,eAAe;IACf,2BAA2B;IAC3B,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,kDAAkD;IAClD,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,4GAA4G;AAChH;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,4GAA4G;IAC5G,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,kCAAkC;IAClC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;AACrB;;;AAGA;IACI;QACI,WAAW;QACX,wBAAwB;QACxB,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,mBAAmB;QACnB,iBAAiB;QACjB,cAAc;QACd,oBAAoB;QACpB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,qCAAqC;QACrC,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,YAAY;QACZ,0BAA0B;QAC1B,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,gBAAgB;QAChB,iBAAiB;QACjB,4GAA4G;IAChH;;IAEA;QACI,aAAa;QACb,gBAAgB;QAChB,YAAY;QACZ,kBAAkB;QAClB,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,WAAW;QACX,iBAAiB;QACjB,kBAAkB;QAClB,4GAA4G;QAC5G,yBAAyB;QACzB,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,YAAY;QACZ,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,WAAW;QACX,gBAAgB;QAChB,oBAAoB;QACpB,YAAY;QACZ,kCAAkC;QAClC,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,kBAAkB;QAClB,iBAAiB;QACjB,gBAAgB;IACpB;AACJ","sourcesContent":[".trip-container{\n    width: 84vw;\n    height: auto;\n    display: flex;\n    flex-flow: wrap;\n    justify-content: flex-start;\n    row-gap: 2.2vw;\n    margin: 4vw auto 2vw;\n}\n\n.trip-card{\n    width: 26.1vw;\n    height: 26.1vw;\n    border: 1px solid rgba(0, 0, 0, 0.12);\n    border-radius: 2vw;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    margin-right: 1.3vw;\n}\n\n.trip-card:hover{\n    transform: scale(1.05);\n    transition: 0.3s;\n    box-shadow: 1px 1px 10px 2px grey; \n}\n\n.upper-card{\n    width: 100%;\n    height: 16vw;\n    overflow: hidden;\n}\n\n.upper-card-img-container{\n    position: absolute;\n    width: 26vw;\n    height: 16vw;\n    border-radius: 2vw 2vw 0 0;\n    overflow: hidden;\n    z-index: 0;\n}\n\n.upper-card-img{\n    width: 100%;\n    height: 16vw;\n    overflow: hidden;\n    object-fit: cover;\n    cursor: pointer;\n}\n\n.trip-category-container{\n    position: relative;\n    width: max-content;\n    /* width:14vw;margin-left:14vw;padding-right: 0; */\n    height: 1.7vw;\n    margin-top: 12.5vw;\n    margin-left: auto;\n    padding-right: 0.5vw;\n    background-image: url(\"https://static.wixstatic.com/media/dd0cc5_7c84882dec3040feaf73ea5dabf78e14~mv2.webp\");\n}\n\n.trip-category-text{\n    margin-top: 0;\n    margin-bottom: 0;\n    color: white;\n    text-align: center;\n    font-size: 1vw;\n    margin-left: 0.5vw;\n    align-self: center;\n    font-family: dm-sans-light;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.vacancy-container{\n    width: 10vw;\n    height: 1.7vw;\n    margin-top: -13vw;\n    margin-left: -2vw;\n    justify-content: center;\n    align-items: center;\n    background-image: url(\"https://static.wixstatic.com/media/dd0cc5_7c84882dec3040feaf73ea5dabf78e14~mv2.webp\");\n    transform: rotate(-38deg);\n    display: flex;\n}\n\n.vacancy-text{\n    font-size: 0.8vw;\n    color: white;\n    font-family: dm-sans-light;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.lower-card{\n    display: flex;\n    flex-direction: column;\n    width: auto;\n    height: 10.1vw;\n    color: black;\n    padding-left: 1vw;\n}\n\n.lower-card-text{\n    font-size: 1.2vw;\n    margin-bottom: 0px;\n    margin-top: 0.5vw;\n    font-family: dm-sans-light;\n    cursor: default;\n}\n\n.lower-card-text-bold{\n    font-weight:bolder;\n    font-family: dm-sans-medium;\n}\n\n.lower-card-button{\n    position: absolute;\n    width: 8vw;\n    height: 2vw;\n    margin-top: 7vw;\n    border-radius: 1vw;\n    border: none;\n    background-color: rgb(230, 84, 57);\n    color: white;\n    font-size: 1.1vw;\n    cursor: pointer;\n    font-family: dm-sans-light;\n}\n\n.lower-card-img{\n    width: 5.6vw;\n    height: 5.6vw;\n    border-radius: 50%;\n    position: absolute;\n    margin-left: 18vw;\n    margin-top: 2.5vw;\n}\n\n\n@media(max-width: 768px){\n    .trip-container{\n        width: 95vw;\n        transform: translateY(0);\n        overflow-x: scroll;\n        height: auto;\n        display: flex;\n        flex-direction: row;\n        flex-flow: nowrap;\n        row-gap: 2.2vw;\n        margin: 4vw auto 2vw;\n        margin-left: 5vw;\n        margin-bottom: 0vw;\n    }\n    \n    .trip-card{\n        min-width: 76vw;\n        height: 93vw;\n        border: 1px solid rgba(0, 0, 0, 0.12);\n        border-radius: 5vw;\n        display: flex;\n        flex-direction: column;\n        overflow: hidden;\n        margin-right: 5vw;\n    }\n    \n    .upper-card{\n        width: 100%;\n        height: 57vw;\n        overflow: hidden;\n    }\n\n    .upper-card-img-container{\n        position: absolute;\n        width: 75.7vw;\n        height: 57vw;\n        border-radius: 5vw 5vw 0 0;\n        overflow: hidden;\n        z-index: -1;\n    }\n    \n    .upper-card-img{\n        width: 100%;\n        height: 57vw;\n        overflow: hidden;\n        object-fit: cover;\n    }\n\n    .trip-category-container{\n        width: 25vw;\n        height: 5vw;\n        margin-top: 46vw;\n        margin-left: 51vw;\n        background-image: url(\"https://static.wixstatic.com/media/dd0cc5_7c84882dec3040feaf73ea5dabf78e14~mv2.webp\");\n    }\n    \n    .trip-category-text{\n        margin-top: 0;\n        margin-bottom: 0;\n        color: white;\n        text-align: center;\n        font-size: 2.2vw;\n        margin-left: 2vw;\n        align-self: center;\n    }\n    \n    .vacancy-container{\n        width: 45vw;\n        height: 4vw;\n        margin-top: -47vw;\n        margin-left: -14vw;\n        background-image: url(\"https://static.wixstatic.com/media/dd0cc5_7c84882dec3040feaf73ea5dabf78e14~mv2.webp\");\n        transform: rotate(-38deg);\n        justify-content: center;\n        align-items: center;\n        display: flex;\n    }\n    \n    .vacancy-text{\n        font-size: 2.4vw;\n        color: white;\n    }\n    \n    .lower-card{\n        display: flex;\n        flex-direction: column;\n        width: auto;\n        height: 36vw;\n        color: black;\n        padding-left: 2vw;\n    }\n    \n    .lower-card-text{\n        font-size: 4vw;\n        margin-bottom: 0px;\n        margin-top: 1vw;\n    }\n    \n    .lower-card-button{\n        position: absolute;\n        width: 30vw;\n        height: 9vw;\n        margin-top: 23vw;\n        border-radius: 100vw;\n        border: none;\n        background-color: rgb(230, 84, 57);\n        color: white;\n        font-size: 4vw;\n    }\n    \n    .lower-card-img{\n        width: 18vw;\n        height: 18vw;\n        border-radius: 50%;\n        position: absolute;\n        margin-left: 52vw;\n        margin-top: 14vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trip-container": `TripCards_trip-container__2efy+`,
	"trip-card": `TripCards_trip-card__12GCk`,
	"upper-card": `TripCards_upper-card__p-Rf6`,
	"upper-card-img-container": `TripCards_upper-card-img-container__NmGsL`,
	"upper-card-img": `TripCards_upper-card-img__oHcox`,
	"trip-category-container": `TripCards_trip-category-container__Bd4gc`,
	"trip-category-text": `TripCards_trip-category-text__XA+m2`,
	"vacancy-container": `TripCards_vacancy-container__7GYCp`,
	"vacancy-text": `TripCards_vacancy-text__8OKGz`,
	"lower-card": `TripCards_lower-card__OVXzc`,
	"lower-card-text": `TripCards_lower-card-text__bM1mC`,
	"lower-card-text-bold": `TripCards_lower-card-text-bold__cCqle`,
	"lower-card-button": `TripCards_lower-card-button__FGdw2`,
	"lower-card-img": `TripCards_lower-card-img__GFfe7`
};
export default ___CSS_LOADER_EXPORT___;
